import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./index.css";
import usFlagIcon from "../../assets/icons/united-states.png";
import brFlagIcon from "../../assets/icons/brazil.png";
import itFLagIcon from "../../assets/icons/italy.png";
import frFlagIcon from "../../assets/icons/france.png";

const TextLanguage = () => {
    const en = "en";
    const pt = "pt";
    const it = "it";

    const localStorageLanguage = localStorage.getItem("language") || en;
    const { i18n } = useTranslation();

    const [enOpacity, setEnOpacity] = useState(1);
    const [ptOpacity, setPtOpacity] = useState(1);
    const [itOpacity, setItOpacity] = useState(1);

    const [language, setLanguage] = useState(localStorageLanguage);
    const [checked, setChecked] = useState(localStorageLanguage);

    const isDisabled = (value) => checked === value;

    const onToggle = (value) => {
        if (isDisabled(value)) return;
        setChecked(value);
        setLanguage(value);
    };

    const getStyle = (disabled, opacity) => ({
        opacity: disabled ? 0.6 : opacity,
        pointerEvents: disabled ? "none" : "auto",
        border: disabled ? "1px solid rgba(0,0,0,0.1)" : "none",
        borderRadius: "6px",
        cursor: disabled ? "default" : "pointer"
    });

    useEffect(() => {
        setLanguage(localStorageLanguage);
    }, []);

    useEffect(() => {
        localStorage.setItem("language", language);
        i18n.changeLanguage(language);
    }, [language, i18n]);

    return (
        <div className="language-container">
            <div className="toggle">

                <div
                    className="toggle-option"
                    style={getStyle(isDisabled(en), enOpacity)}
                >
                    <img
                        src={usFlagIcon}
                        alt="us-flag"
                        onMouseOver={() => !isDisabled(en) && setEnOpacity(0.3)}
                        onMouseOut={() => !isDisabled(en) && setEnOpacity(1)}
                        onClick={() => {
                            onToggle(en);
                            setEnOpacity(1);
                        }}
                    />
                </div>

                <div
                    className="toggle-option"
                    style={getStyle(isDisabled(pt), ptOpacity)}
                >
                    <img
                        src={brFlagIcon}
                        alt="br-flag"
                        onMouseOver={() => !isDisabled(pt) && setPtOpacity(0.3)}
                        onMouseOut={() => !isDisabled(pt) && setPtOpacity(1)}
                        onClick={() => {
                            onToggle(pt);
                            setPtOpacity(1);
                        }}
                    />
                </div>

                <div
                    className="toggle-option"
                    style={getStyle(isDisabled(it), itOpacity)}
                >
                    <img
                        src={itFLagIcon}
                        alt="it-flag"
                        onMouseOver={() => !isDisabled(it) && setItOpacity(0.3)}
                        onMouseOut={() => !isDisabled(it) && setItOpacity(1)}
                        onClick={() => {
                            onToggle(it);
                            setItOpacity(1);
                        }}
                    />
                </div>

            </div>
        </div>
    );
};

export default TextLanguage;